
import { css } from 'lit';
export default css`
.hf-search-facets__item {
  border-bottom-width: 1px;
}
  .hf-search-facets__item {
  border-style: solid;
}
  .hf-search-facets__item {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}
  .hf-search-facets__item {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
  .hf-search-facets__item {
  padding-left: 0px;
  padding-right: 0px;
}
  .hf-search-facets__clear {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
  .hf-search-facets__clear {
  font-weight: 700;
}
  .hf-search-facets__clear {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  .hf-search-facets__clear {
    cursor: pointer;
    margin-left: 30px;
  }
  .hf-search-facets__clear:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}
  .hf-search-facets__clear:hover {
  text-decoration: underline;
}
  .hf-search-facets--facets--modal {
    margin-top: 40px;
  }
  .hf-search-facets--facets--modal .hf-search-facets__clear {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
  .hf-search-facets--facets--modal .hf-search-facets__clear {
  text-decoration: underline;
}
  .hf-search-facets--facets--modal .hf-search-facets__clear {
      font-size: 13px;
      position: absolute;
      left: 0;
      margin-left: 21px;
    }
  .hf-search-facets--facets--modal .hf-search-facets__item {
      border: 0;
      padding-top: 0;
      padding-bottom: 27px;
      margin-left: 19px;
    }
`;